import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Add from '@material-ui/icons/Add'
import Remove from '@material-ui/icons/Remove'
const styles = theme => ({
  container: {
    padding: theme.spacing.unit
  },
  name: {
    width: 100,
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2
  },
  counter: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2
  }
})
export default withStyles(styles)(
  class PlayersSelectionComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      players: PropTypes.array.isRequired,
      onChange: PropTypes.func.isRequired,
      mini: PropTypes.bool
    }
    static defaultProps = {
      players: [],
      mini: false
    }
    handleChange = (index, action) => e => {
      const { players } = this.props
      let count
      if (action === '-' && players[index].count > 0) {
        count = players[index].count - 1
        this.props.onChange(index, count)
      } else {
        count = players[index].count + 1
        this.props.onChange(index, count)
      }
    }

    render() {
      const { classes, players, mini } = this.props
      return (
        <Grid item xs={12}>
          {players.map((p, i) => (
            <Grid
              className={classes.container}
              key={i}
              container
              direction="row"
              alignItems="center"
              justify="space-between">
              <Grid item>
                <Typography variant="subheading" className={classes.name}>
                  {p.name}
                </Typography>
              </Grid>
              <Grid item>
                <Button
                  onClick={this.handleChange(i, '-')}
                  color="secondary"
                  variant="fab"
                  mini={mini}
                  disabled={p.count < 1}>
                  <Remove color="inherit" />
                </Button>
              </Grid>
              <Grid item>
                <Typography variant="subheading" className={classes.counter}>
                  {' '}
                  {p.count}{' '}
                </Typography>
              </Grid>
              <Grid item>
                <Button
                  onClick={this.handleChange(i, '+')}
                  color="primary"
                  mini={mini}
                  variant="fab">
                  <Add color="inherit" />
                </Button>
              </Grid>
            </Grid>
          ))}
        </Grid>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/players/PlayersSelectionComponent.js